export default "/videos/1fa6424dbccdf052f28289b706fbebd1.mp4";